// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__11jrg","itemTitle":"ClientEmergencyInfo_itemTitle__3Z6Gv","itemText":"ClientEmergencyInfo_itemText__1sWR1"};